<app-spinner></app-spinner>
@if(isUserLoggedIn)
{
  <div class="page">
    <app-header [userDetails]="userDetails"></app-header>
  
    <div class="container">
      @if (showCategoriesAndFooter) {
        <app-categories></app-categories>
      }
      <router-outlet />
    </div>
  
    @if (showCategoriesAndFooter) {    
       <app-footer [footerData]="footerData"></app-footer> 
    }  
    
    <app-info [infoData]="infoData"></app-info>  
  
    <app-scroll-top></app-scroll-top>  
  </div>
}

